// extracted by mini-css-extract-plugin
export default {"root":"FormGroups_root__l44Z+","section-divider":"FormGroups_section-divider__vp6qK"};